module.exports = __webpack_public_path__ + "static/img/11bg_5.245012b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/11bg_5.png
// module id = 633
// module chunks = 1